import React from 'react';

const HorizontalLine = () => (
  <svg width="532" height="2" viewBox="0 0 520 2" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 1L520 0.999955" stroke="#E7E9EF" strokeWidth="2" />
  </svg>
);

export default HorizontalLine;
